<div class="fixed z-50 overflow-hidden transition-all shadow-md root-container h-100 bg-gray-50 dark:bg-darkBack800" [ngClass]="sidebar.isCollapsed ? 'w-0 md:w-24' : 'w-72 sm:w-80'">
  <div class="flex flex-col h-full p-3">
    <div class="flex text-xl " [ngClass]="!sidebar.isCollapsed ? 'justify-end ' : 'justify-center'">
      <button class="menu-btn" (click)="sidebar.toggle()">
        <i class="fa-solid fa-bars"></i>
      </button>
    </div>

    <a [routerLink]="['/']" class="mx-auto my-10 max-w-48 min-h-9" >
      @if (!sidebar.isCollapsed) {
        <img src="assets/images/brand-logo-black.png" class="flex dark:hidden" alt="Philippine vex robotics">
        <img src="assets/images/brand-logo.png" class="hidden dark:flex" alt="Philippine vex robotics">
      }
    </a>

   <div class="custom-scrollbar overflow-y-auto h-full">

       <div class="pt-3 border-t border-gray-200">
        @for (link of sidebarLinks; track $index) {
          <a [routerLink]="[link.href]" routerLinkActive="active"  class="sidebar-link" [ngClass]="{collapsed: sidebar.isCollapsed}">
            <i [class]="link.icon"></i>
            <span>{{ link.label }}</span>
          </a>
        }
       </div>

       <div>
        <toggle-dark [size]="1.8" [hasLabel]="!sidebar.isCollapsed"  [classes]="'py-3 px-2 text-gray-400 text-base hover:bg-slate-100 hover:text-darkgray rounded-md flex items-center dark:hover:bg-darkBack700 dark:hover:text-gray-50 ' + (sidebar.isCollapsed ? 'justify-center' : '')" />
        <div class="cursor-pointer sidebar-link" [ngClass]="{collapsed: sidebar.isCollapsed}"  (click)="logout()">
          <i class="text-2xl rotate-180 fa-solid fa-arrow-right-from-bracket"></i> <span>Log out</span>
        </div>
       </div>
     </div>

  </div>
</div>
